<template>
    <v-list class="py-0">
        <v-list-item
            v-for="(item, index) in items"
            :key="index"
            dense
            class="menu-list-item menu-list-item v-list-item v-list-item--dense v-list-item--link theme--light"
            :class="textColor"
            :ripple="false"
            :style="{ computedMinWidth, minHeight: '32px' }"
            style="height: 32px;"
            tabindex="0"
            @click="select(item)"
        >
            <div style="display: contents">
                <v-list-item-avatar
                    v-if="avatars"
                    size="24"
                    :tile="avatarCircularRuleFunc(item)"
                    style=""
                    :color="!!item[avatarKey] ? 'white' : item[colorKey] ? item[colorKey] : 'grey lighten-2'"
                >
                    <img v-if="item[avatarKey]" :src="item[avatarKey]" />
                    <span
                        v-else
                        :style="item[avatarInitialsKey].length > 2 ? 'font-size: 10px' : 'font-size: 14px'"
                        :class="[item[avatarInitialsClassKey], avatarInitialsClass]"
                    >
                        {{ item[avatarInitialsKey] }}
                    </span>
                </v-list-item-avatar>
                <v-list-item-icon v-if="item[iconKey]">
                    <v-icon :color="iconColor">
                        {{ item[iconKey] }}
                    </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title
                        :class="isSelected(item) ? 'font-weight-bold' : ''"
                        :style="capitalize ? 'text-transform:capitalize' : ''"
                    >
                        <slot :item="item" name="tile-content">
                            {{ itemName(item) }}
                        </slot>
                    </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="enableHoverAction" class="ma-0 pa-0">
                    <v-btn icon right class="hover-action ma-0" @click.stop="hoverAction(item)">
                        <v-icon small :color="color">
                            mdi-delete
                        </v-icon>
                    </v-btn>
                </v-list-item-action>
                <v-list-item-action v-else>
                    <v-icon v-show="isSelected(item)" :color="color" style="margin-top:-5px">
                        {{ icon }}
                    </v-icon>
                </v-list-item-action>
            </div>
        </v-list-item>
    </v-list>
</template>
<script>

/**
 * Replace with the dropmenu that our filters use, will cause some issues with appNavigationDrawer
 */

export default {
    name: "DropMenuList",
    props: {
        items: {
            type: Array,
            default: () => []
        },
        isSelected: {
            type: Function,
            default: () => {}
        },
        itemName: {
            type: Function,
            default: () => {}
        },
        icon: {
            type: String,
            default: "mdi-check"
        },
        iconColor: {
            type: String,
            default: "grey"
        },
        color: {
            type: String,
            default: "primary"
        },
        enableHoverAction: {
            type: Boolean,
            default: false
        },
        hoverAction: {
            type: Function,
            default: () => {}
        },
        capitalize: {
            type: Boolean,
            default: false
        },
        iconKey: {
            type: String,
            default: ""
        },
        avatars: {
            type: Boolean,
            default: false
        },
        avatarCircularRuleFunc: {
            type: Function,
            default: () => true
        },
        avatarInitialsKey: {
            type: String,
            default: ""
        },
        avatarInitialsClass: {
            type: String,
            default: ""
        },
        avatarInitialsClassKey: {
            type: String,
            default: "initials_class"
        },
        avatarKey: {
            type: String,
            default: ""
        },
        colorKey: {
            type: String,
            default: ""
        },
        computedMinWidth: {
            type: String,
            default: ""
        },
        textColor: {
            type: String,
            default: "grey--text text--darken-2"
        },
        select: {
            type: Function,
            default: () => {}
        }
    }
};
</script>
